import "@/App.css";
import { Crosshair, Youtube, Instagram, Facebook, ExternalLink, Play } from "lucide-react";

const CHANNEL_URL = "https://www.youtube.com/@trajkataa";
const CHANNEL_ID = "UCnuMDGARKUIYsm6Wa-plytQ";
const AVATAR_URL =
    "https://yt3.googleusercontent.com/MEfXglp-LYc3xRchrQ5xj8XY_JCDpbY8zA33BLht61q4bgp76SPlvOQv7BloTUzz57Wo8BO8=s900-c-k-c0x00ffffff-no-rj";

const LATEST_VIDEOS = [
    {
        id: "IIXg0FnoSJs",
        title: "PUBG PC — ERANGEL — Dominating in the End & WIN 🤑",
        meta: "Latest Upload",
        live: false,
    },
    {
        id: "Txf9C_M2cxY",
        title: "PUBG LIVE 🚀 — No losses today (Hopefully...)",
        meta: "Stream",
        live: true,
    },
    {
        id: "f_9MzsEWBKI",
        title: "PUBG LIVE 🚀 — Potato Power in PUBG! 💥",
        meta: "Stream",
        live: true,
    },
    {
        id: "3svzSKXxQ_M",
        title: "PUBG LIVE 🚀 — Balkan Power in PUBG! 💥",
        meta: "Stream",
        live: true,
    },
    {
        id: "EaXwfj9QOaM",
        title: "PUBG LIVE 2K — Potato Aim Trying To WIN Chicken 🥔",
        meta: "Stream",
        live: true,
    },
    {
        id: "W910J-FdBmk",
        title: "PUBG LIVE 🚀 — Potato Power in PUBG! 💥",
        meta: "Stream",
        live: true,
    },
];

function Backdrop() {
    return (
        <>
            <div className="tk-backdrop" />
            <div className="tk-grid" />
            <div className="tk-noise" />
        </>
    );
}

function Nav() {
    return (
        <nav className="tk-nav" data-testid="site-navbar">
            <div className="tk-logo">
                <div className="tk-logo-mark">
                    <Crosshair size={18} strokeWidth={2.4} />
                </div>
                <div className="tk-logo-text">TRAJKATA</div>
            </div>
            <div className="tk-nav-links">
                <a href="#about" data-testid="nav-about">About</a>
                <a href="#videos" data-testid="nav-videos">Videos</a>
                <a href="#subscribe" data-testid="nav-subscribe">Subscribe</a>
                <a
                    className="tk-btn tk-btn-ghost"
                    href={CHANNEL_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid="nav-youtube-link"
                >
                    <Youtube size={16} /> YouTube
                </a>
            </div>
        </nav>
    );
}

function Hero() {
    return (
        <section className="tk-hero" data-testid="hero-section">
            <div>
                <div className="tk-eyebrow tk-reveal d1" data-testid="hero-eyebrow">
                    <span className="tk-dot" />
                    PUBG: Battlegrounds · North Macedonia
                </div>
                <h1 className="tk-title tk-reveal d2" data-testid="hero-title">
                    The <span className="accent">Chicken Dinner</span>
                    <br /> Journey
                </h1>
                <p className="tk-sub tk-reveal d3" data-testid="hero-description">
                    I'm Trajko / TRAJKATA, and I play PUBG: Battlegrounds for the
                    vibes, the laughs, and the occasional accidental Chicken
                    Dinner. If you're looking for a Top 10 pro — you're in the
                    wrong place. 😀
                </p>
                <div className="tk-cta-row tk-reveal d3">
                    <a
                        className="tk-btn"
                        href={CHANNEL_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="hero-watch-button"
                    >
                        <Play size={16} fill="#fff" /> Watch on YouTube
                        <ExternalLink size={14} />
                    </a>
                    <a
                        className="tk-btn tk-btn-ghost"
                        href={`${CHANNEL_URL}/videos`}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="hero-videos-button"
                    >
                        Browse Videos
                    </a>
                </div>

                <div className="tk-stats tk-reveal d4" data-testid="hero-stats">
                    <div>
                        <div className="tk-stat-num">74</div>
                        <div className="tk-stat-label">Subscribers</div>
                    </div>
                    <div>
                        <div className="tk-stat-num">66</div>
                        <div className="tk-stat-label">Videos</div>
                    </div>
                    <div>
                        <div className="tk-stat-num">115K+</div>
                        <div className="tk-stat-label">Total Views</div>
                    </div>
                    <div>
                        <div className="tk-stat-num">2010</div>
                        <div className="tk-stat-label">Since</div>
                    </div>
                </div>
            </div>

            <div className="tk-reveal d2">
                <div className="tk-avatar-wrap">
                    <div className="tk-avatar-frame">
                        <img
                            src={AVATAR_URL}
                            alt="TRAJKATA channel avatar"
                            className="tk-avatar-img"
                            referrerPolicy="no-referrer"
                            data-testid="hero-avatar"
                        />
                    </div>
                    <span className="tk-corner tl" />
                    <span className="tk-corner tr" />
                    <span className="tk-corner bl" />
                    <span className="tk-corner br" />
                    <div className="tk-badge-floating" data-testid="chicken-badge">
                        <span className="tk-chicken">🍗</span>
                        <span className="tk-mono">Winner Winner</span>
                    </div>
                </div>
            </div>
        </section>
    );
}

function About() {
    return (
        <section className="tk-section" id="about" data-testid="about-section">
            <div className="tk-section-head">
                <div>
                    <div className="tk-section-tag">// 01 — About the Channel</div>
                    <h2 className="tk-section-title">
                        The PUBG <span className="accent">Journey</span> 🎯🏆
                    </h2>
                </div>
            </div>

            <div className="tk-about">
                <div className="tk-about-card red" data-testid="about-me-card">
                    <h3>About Me</h3>
                    <p>
                        I'm Trajko / TRAJKATA, and I play PUBG: Battlegrounds for
                        the vibes, the laughs, and the occasional accidental
                        Chicken Dinner.
                    </p>
                    <p>
                        If you're looking for a Top 10 pro — you're in the wrong
                        place. 😀 We're here to relax, miss headshots, and
                        celebrate when the chaos finally lands in our favor.
                    </p>
                </div>

                <div className="tk-about-card blue" data-testid="about-expect-card">
                    <h3>What to Expect</h3>
                    <ul className="tk-rules">
                        <li>
                            The Human Behind the Headshots (Usually Missing Them) 😀
                        </li>
                        <li>
                            We're here to relax. If you're looking to argue you are
                            at the right place.
                            If you are toxic — the Blue Zone is that way. ➡️
                        </li>
                        <li>
                            No Backseat Gaming (unless asked). I know I'm playing
                            like a potato, but I'm a happy potato.
                        </li>
                        <li>
                            Positive Vibes Only. No hate speech, racism, or being
                            weirdly aggressive. Just be weird.
                        </li>
                        <li>
                            No Spamming. Unless we actually win a game — then you
                            can flood the chat with 🍗.
                        </li>
                    </ul>
                </div>
            </div>
        </section>
    );
}

function Videos() {
    return (
        <section className="tk-section" id="videos" data-testid="videos-section">
            <div className="tk-section-head">
                <div>
                    <div className="tk-section-tag">// 02 — Latest Drops</div>
                    <h2 className="tk-section-title">
                        Recent <span className="accent">Streams &amp; Videos</span>
                    </h2>
                </div>
                <a
                    className="tk-btn tk-btn-ghost"
                    href={`${CHANNEL_URL}/videos`}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid="videos-see-all"
                >
                    See all <ExternalLink size={14} />
                </a>
            </div>

            <div className="tk-videos">
                {LATEST_VIDEOS.map((v, i) => (
                    <article
                        key={v.id}
                        className="tk-video-card"
                        data-testid={`video-card-${i}`}
                    >
                        <div className="tk-video-iframe-wrap">
                            <iframe
                                src={`https://www.youtube-nocookie.com/embed/${v.id}?rel=0`}
                                title={v.title}
                                loading="lazy"
                                allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                allowFullScreen
                            />
                        </div>
                        <div className="tk-video-body">
                            <div className="tk-video-meta">
                                {v.live ? (
                                    <span className="live">● {v.meta}</span>
                                ) : (
                                    <span>{v.meta}</span>
                                )}
                            </div>
                            <h3 className="tk-video-title">{v.title}</h3>
                        </div>
                    </article>
                ))}
            </div>
        </section>
    );
}

function SubscribeBand() {
    return (
        <section
            className="tk-cta-band"
            id="subscribe"
            data-testid="subscribe-section"
        >
            <h2>
                Drop a sub, hit that bell —{" "}
                <span style={{ color: "var(--tk-red-glow)" }}>let's go!</span>
            </h2>
            <p>Join the squad before the next chicken dinner. 🍗</p>

            <div className="tk-subscribe-embed" data-testid="subscribe-embed">
                <img
                    src={AVATAR_URL}
                    alt="TRAJKATA channel avatar"
                    referrerPolicy="no-referrer"
                    className="tk-sub-avatar"
                />
                <div className="tk-sub-info">
                    <div className="tk-sub-name">TRAJKATA</div>
                    <div className="tk-sub-handle">@trajkataa</div>
                </div>
                <a
                    className="tk-sub-btn"
                    href={`${CHANNEL_URL}?sub_confirmation=1`}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid="subscribe-action-button"
                >
                    <Youtube size={18} /> Subscribe
                </a>
            </div>

            
        </section>
    );
}

function Footer() {
    return (
        <footer className="tk-footer" data-testid="site-footer">
            <div style={{ marginBottom: 12 }}>
                <a
                    href={CHANNEL_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid="footer-youtube"
                >
                    <Youtube size={14} style={{ display: "inline", marginRight: 6 }} />
                    YouTube
                </a>
                <a
                    href="https://www.instagram.com/trajkataa/"
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid="footer-instagram"
                >
                    <Instagram size={14} style={{ display: "inline", marginRight: 6 }} />
                    Instagram
                </a>
                <a
                    href="https://www.facebook.com/trajche.toshev/"
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid="footer-facebook"
                >
                    <Facebook size={14} style={{ display: "inline", marginRight: 6 }} />
                    Facebook
                </a>
            </div>
            <div>© {new Date().getFullYear()} TRAJKATA · Fan Page · Stay positive 🍗</div>
        </footer>
    );
}

function App() {
    return (
        <div className="App">
            <Backdrop />
            <div className="tk-shell">
                <Nav />
                <Hero />
                <About />
                <Videos />
                <SubscribeBand />
                <Footer />
            </div>
        </div>
    );
}

export default App;
